import * as React from 'react';
import { activityActionTypes } from './activity-action-types';
import { IClientLogsData } from '../../views/developers/ClientLogs';

export interface IActivityAction {
	type: activityActionTypes,
	payload?: any
}

export interface IUseActivity {
	activityState: IActivityContextState;
	dispatch: React.Dispatch<IActivityAction>;
}

export interface IActivityContextState {
	clientsLogsData: IClientLogsData,
	isClientsLogsDataLoading: boolean,
}

export const defaultState = {
	count: 0,
	currentPage: 1,
	totalPages: 1,
	nextPage: null,
	prevPage: null,
	pageSize: 1,
	displayData: []
};
